import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const setMailchimpListId = async (domain: string, listId: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop/mailchimp-list-id',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { listId },
        domain,
        isEncrypted: true,
    });
}